import { QuestionMark } from '@mui/icons-material';

import { IconProps } from '.';

export const QuestionMarkIcon = ({ className, size }: IconProps) => {
  return <QuestionMark width={size} height={size} className={className} />;
};
